import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const WrenchIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.83 3.69999L12.77 6.74999L9.93 6.04999L9.23 3.21999L12.29 0.169986C10.62 -0.270014 8.77 0.149986 7.46 1.45999C6 2.90999 5.63 5.02999 6.34 6.81999L0.58 12.58C0.22 12.94 0 13.44 0 13.99C0 15.09 0.9 15.99 2 15.99C2.55 15.99 3.05 15.77 3.41 15.4L9.18 9.62999C10.97 10.32 13.09 9.95999 14.53 8.50999C15.85 7.20999 16.27 5.35999 15.83 3.69999Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default WrenchIcon;
